import { default as SearchLocationByGoogle } from './SearchLocation';
import { default as SearchLocationByUconxAutocomplete } from './SearchLocationByUconxAutocomplete';

let searchEngine = SearchLocationByGoogle;
if (process.env.REACT_APP_ADDRESS_SEARCH_ENGINE === 'autocomplete') {
  searchEngine = SearchLocationByUconxAutocomplete;
}

export default searchEngine;
